import React from "react";

const ValueCell = ({ value, formatNumber, treatZeroAsMissing }) => {
  const showAsMissing = value == null || (treatZeroAsMissing && value === 0);
  const displayValue = showAsMissing ? "--" : formatNumber(value);
  return (
    <span className={showAsMissing ? "text-theme-text opacity-40" : "text-theme-text"}>
      {displayValue}
    </span>
  );
};

export default ValueCell;
